import React, { FC } from 'react';

import {
  IAdminRequestedPharmacistsData,
  PharmacyLegendVariant,
  ProfessionalReplacementTypes,
  adminActions,
} from '@pharmaplan/common';

import { Button, Typography } from '@mui/material';
import CustomAvatarSection from '../../../common/CustomAvatarSection';
import { genericConfigBuilder } from '../../AvailableWorkshifts/helpers';
import useRequestedPharmacistActions from '../../../../hooks/AvailableWorkshift/useRequestedPharmacistActions';
import useSelfService from '../../../../hooks/useSelfService';
import { LocationText } from '../../AvailableWorkshifts/AvailableWorkshifts';

import CounterOfferChip from '../../../common/CounterOfferChip';
import strings from '../../../../localization';

import styles from './styles';
import { ReplacementLabels } from '../../../../helpers/Constants';

interface IPharmacistList {
  event: IAdminRequestedPharmacistsData;
  image?: string;
  isAutoSyncRecord?: boolean;
}

const PharmacistList: FC<IPharmacistList> = ({
  event,
  image,
  isAutoSyncRecord,
}) => {
  const {
    pharmacistName,
    pharmacistCity,
    bookingId,
    workshiftId,
    startDate,
    pharmacistHourlyRate,
    pharmacyId,
    professionalCity,
    professionalName,
    counterOfferId,
    counterHourlyRate,
    replacementType,
    externalPharmacistId,
    pharmacistId,
    professionalId,
    longTermShiftContract,
  } = event ?? {};

  const { isSelfService } = useSelfService();
  const externalPharmacist = isSelfService ? '' : externalPharmacistId;
  const { actions, viewDetailsAction } = useRequestedPharmacistActions(
    isAutoSyncRecord,
    externalPharmacist,
  );

  const id = isSelfService ? professionalId : pharmacistId;
  const name = isSelfService ? professionalName ?? '' : pharmacistName;
  const city = isSelfService ? professionalCity ?? '' : pharmacistCity;

  const { longTermShiftContractId } = longTermShiftContract ?? {};

  const config = genericConfigBuilder(
    <LocationText label={city} />,
    ReplacementLabels[
      replacementType ?? ProfessionalReplacementTypes.pharmacist
    ],
  );

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    viewDetailsAction({
      bookingId,
      workshiftId,
      pharmacyId,
      pharmacistId: id,
      longTermShiftContractId,
    })();
  };

  return (
    <Button disableRipple sx={styles.container} onClick={handleClick}>
      {!!counterOfferId && <CounterOfferChip />}
      <CustomAvatarSection
        isAutoSyncRecord={!!externalPharmacist}
        successAction={adminActions.getRequestedPharmacists}
        config={config}
        hourlyRate={counterOfferId ? counterHourlyRate : pharmacistHourlyRate}
        title={name}
        avatar={image}
        shiftType={PharmacyLegendVariant.requested}
        menuActions={actions(
          bookingId,
          workshiftId,
          startDate,
          pharmacyId,
          longTermShiftContractId,
          id,
        )}
        customContainerStyle={styles.avatarContainer}
        strikeRate={counterOfferId ? pharmacistHourlyRate : null}
        customFooter={
          !!externalPharmacist && (
            <Typography sx={styles.footerLabel}>
              {strings.requestedShiftsWarning}
            </Typography>
          )
        }
      />
    </Button>
  );
};

export default PharmacistList;
